'use strict';

function getGuideSearchLocationValue(prediction, place) {
  var detailedPlace = {
    placeId: prediction.placeId,
    name: prediction.description,
  };

  if (place.geometry) {
    // LAT LON
    if (place.geometry.location) {
      detailedPlace.lat = place.geometry.location.lat;
      detailedPlace.lon = place.geometry.location.lng;
    }

    // PX, PY
    if (place.geometry.viewport) {
      if (place.geometry.viewport.f && place.geometry.viewport.b) {
        // detailedPlace.px2 = place.geometry.viewport.southwest.lat;
        // detailedPlace.py2 = place.geometry.viewport.southwest.lng;
        detailedPlace.px2 = place.geometry.viewport.f.f;
        detailedPlace.py2 = place.geometry.viewport.b.b;

        // detailedPlace.px1 = place.geometry.viewport.northeast.lat;
        // detailedPlace.py1 = place.geometry.viewport.northeast.lng;
        detailedPlace.px1 = place.geometry.viewport.f.b;
        detailedPlace.py1 = place.geometry.viewport.b.f;
      }
    }
  }

  // COUNTRY CODE
  place.address_components.forEach((value) => {
    if (value.types[0] === 'country') {
      detailedPlace.countryCode = value.short_name;
    }
  });

  return detailedPlace;
}

export default class PlacesService {
  constructor($http, utils, autocompleteService) {
    'ngInject';

    this.utils = utils;
    this.$http = $http;
    this.autocompleteService = autocompleteService;
  }

  getDetails(place, callback) {
    this.autocompleteService.getPlaceDetails(place.placeId).then(
      function(detailedPlace){
        callback(getGuideSearchLocationValue(place, detailedPlace.data));
      }
    );
  }

  getPlaceId(slug) {
    if(slug == undefined || slug == ''){
      return false;
    }
    return this.$http.get(this.utils.getApiUrl('locations/') + slug);
  }
}



// WEBPACK FOOTER //
// ./app/src/services/places_service.js